import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { Icons } from "./data";
import Typography from "components/typography";
import Modal from "components/modal";
import AddLinkModal from "../modals/addLinkModal";

interface IProps {
  platform: "Instagram" | "Facebook" | "Tik Tok" | "X";

  link?: string;
  setLink: (link: string) => void;
  disabled?: boolean;
}
const PlatformItem = ({ platform, link, setLink, disabled }: IProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <Container>
      <Logo>{link ? Icons[platform].active : Icons[platform].inactive}</Logo>
      <Text>
        <Typography size="xl" color={Colors.grey100} weight="medium" mb="0.4">
          {platform}
        </Typography>

        {link ? (
          <Typography color={Colors.grey500}>{link}</Typography>
        ) : (
          <Typography color={Colors.grey600}>Please Add</Typography>
        )}
      </Text>
      {link ? (
        <EditButton onClick={() => setModalOpen(true)}>
          <Typography color={Colors.grey400} mr="1">
            Edit
          </Typography>
          <Icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M8.17931 2.53933L8.64271 2.07589C9.41055 1.30804 10.6555 1.30804 11.4234 2.07589C12.1912 2.84374 12.1912 4.08867 11.4234 4.85653L10.9599 5.31996M8.17931 2.53933C8.17931 2.53933 8.23721 3.52414 9.10615 4.39309C9.9751 5.26203 10.9599 5.31996 10.9599 5.31996M8.17931 2.53933L3.91867 6.79994C3.63009 7.08854 3.4858 7.23279 3.36171 7.39189C3.21533 7.57959 3.08984 7.78264 2.98744 7.99749C2.90063 8.17964 2.83611 8.37324 2.70705 8.76039L2.16017 10.401M10.9599 5.31996L6.69931 9.58059C6.41071 9.86914 6.26646 10.0134 6.10736 10.1375C5.91967 10.2839 5.71661 10.4094 5.50175 10.5118C5.31961 10.5986 5.12602 10.6631 4.73885 10.7922L3.09823 11.3391M2.16017 10.401L2.02649 10.8021C1.96298 10.9926 2.01257 11.2026 2.15458 11.3447C2.2966 11.4867 2.50666 11.5363 2.69719 11.4728L3.09823 11.3391M2.16017 10.401L3.09823 11.3391"
                stroke="#CDCDCD"
                stroke-width="0.874999"
              />
            </svg>
          </Icon>
        </EditButton>
      ) : (
        <AddButton
          onClick={() => (disabled ? null : setModalOpen(true))}
          style={{
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? "not-allowed" : "pointer"
          }}
        >
          <Typography color="white" mr="1">
            ADD
          </Typography>
          <Icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M7.00008 12.8333C10.2217 12.8333 12.8334 10.2217 12.8334 6.99999C12.8334 3.77833 10.2217 1.16666 7.00008 1.16666C3.77842 1.16666 1.16675 3.77833 1.16675 6.99999C1.16675 10.2217 3.77842 12.8333 7.00008 12.8333Z"
                stroke="white"
                stroke-width="1.05"
              />
              <path
                d="M8.75 7H7M7 7H5.25M7 7V5.25M7 7V8.75"
                stroke="white"
                stroke-width="1.05"
                stroke-linecap="round"
              />
            </svg>
          </Icon>
        </AddButton>
      )}
      {modalOpen && (
        <Modal isActive={modalOpen} closeModal={() => setModalOpen(false)}>
          <AddLinkModal
            platform={platform}
            close={() => setModalOpen(false)}
            setLink={(link) => setLink(link)}
            link={link || ""}
            save={() => setModalOpen(false)}
          />
        </Modal>
      )}
    </Container>
  );
};

export default PlatformItem;

const Container = styled.div`
  width: 100%;
  padding: 1.9rem 1.6rem;
  border-top: 0.5px solid ${Colors.grey600};
  display: flex;
  align-items: center;
`;

const Logo = styled.div`
  width: 3.2rem;
  height: 3.2rem;
`;

const Text = styled.div`
  margin-left: 1.2rem;
`;

const EditButton = styled.div`
  margin-left: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
const Icon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;

const AddButton = styled.div`
  padding: 1.2rem;
  border-radius: 0.8rem;
  border: 0.5px solid #fff;
  margin-left: auto;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
